<template>
  <v-bottom-sheet v-model="realShow" class="dishDetailSheet" max-width="600px" width="100vw">
    <v-card
      v-if="dish"
      id="card"
      class="d-flex flex-column align-center"
      max-height="calc(100vh - 24px)"
      style="border-top-right-radius: 16px;border-top-left-radius: 16px;position: relative;overflow: scroll"
    >
      <div v-dragscroll style="max-height: calc(100vh - 24px);overflow-y: scroll;width: 100%">
        <v-img
          :aspect-ratio="16/12"
          :src="dish.cloudImage"
          width="100%"
        >
          <template #placeholder>
            <v-card>
              <v-responsive :aspect-ratio="1">
                <div class="d-flex align-center justify-center" style="height: 100%">
                  <v-icon large>mdi-image</v-icon>
                </div>
              </v-responsive>
            </v-card>
          </template>
        </v-img>
        <div class="pa-4" style="width: 100%">
          <div class="text-h6 font-weight-black">{{ dish.dishName }}</div>
          <div class="text-body-2 text--secondary mt-1" v-html="currentDescDisplay || $t('EmptyMenuDesc')"></div>
          <div
            v-if="dish.AllergenName"
            class="text-body-2 mt-1 text--secondary"
            v-html="dish.AllergenName"
          ></div>
        </div>
        <template v-if="dish.modInfo&&show&&computedOption.length>0">
          <div class="text-body-2 px-4 font-weight-black mt-8 d-flex">
            🥗
            <v-spacer></v-spacer>
            <template v-if="attrLimit!==-1">
              {{ multipleSelected }}/{{ attrLimit }}
            </template>
          </div>

          <div
            class="px-4 mt-4"
            style="width: 100%;"
          >
            <template v-for="item in computedOption">
              <div
                :key="'mod2head'+item.id"
                class="d-flex align-center text-caption font-weight-black mb-1"
              >
                {{ item.name }}
              </div>
              <template v-if="item.multiSelect!=='1'">
                <v-select
                  :key="'mod2'+item.id"
                  v-model="mod[item.id]"
                  :item-text="itemText"
                  :items="item.select"
                  :menu-props="{overflowY:true,offsetOverflow:true,offsetY:true}"
                  class="mb-2"
                  dense
                  hide-details
                  item-value="index"
                  outlined
                >
                </v-select>
              </template>
              <div
                v-else
                :key="'mod2'+item.id"
                class="mt-2"
              >
                <v-item-group
                  :mandatory="item.required==='1'"
                  :multiple="item.multiSelect==='1'"
                >
                  <v-item
                    v-for="(s,index) in item.select"
                    :key="'mod111'+index"
                  >
                    <v-card
                      class="mb-2 text-body-2 d-flex"
                      elevation="0"
                    >
                      <div class="text-body-2 flex-grow-1 mr-2">
                        <div>{{ s.text }}</div>
                        <div>{{ s.priceInfo }}</div>
                      </div>
                      <div class="d-flex justify-center align-center">
                        <v-btn
                          v-if="s.count > 0"
                          icon
                        >
                          <v-icon @click.stop="countMinus(s)">
                            mdi-minus-circle
                          </v-icon>
                        </v-btn>
                        <div
                          v-if="s.count > 0"
                          class="text-body-1 font-weight-bold mx-2"
                        >{{ s.count }}
                        </div>
                        <v-btn
                          :disabled="item.maxCount!=='-1'&&currentGroupList(item) >= item.maxCount || multipleSelected >= attrLimit && attrLimit !== -1"
                          icon
                        >
                          <v-icon @click.stop="countPlus(s)">
                            mdi-plus-circle
                          </v-icon>
                        </v-btn>
                      </div>

                    </v-card>
                  </v-item>
                </v-item-group>
              </div>
            </template>
          </div>
        </template>
        <div class="pa-4">
          <div class="d-flex align-center text-caption font-weight-black mb-1">Note</div>
          <v-textarea clearable v-model="note" outlined></v-textarea>
        </div>
        <div class="flex-shrink-0" style="height: 240px;width: 100%"></div>
        <v-card
          v-if="dish.isActive==='1'" class="pa-2 px-4" color="grey darken-3"
          style="position: fixed;bottom: 0;width: 100%;"
          tile
        >
          <div class="d-flex align-center">
            <div>
              <div class="text-h6 font-weight-bold">
                {{ realPrice | priceDisplay }}
              </div>
              <div v-if="selectedModString" class="d-flex align-center">
                <v-icon class="mr-2 text--secondary" small>mdi-heart-outline</v-icon>
                <div class="text-caption text--secondary">{{ selectedModString }}</div>
              </div>
            </div>
            <v-spacer></v-spacer>
            <div
              v-if="store.state.cantOrderDishes !== '1'" class=" d-flex align-center grey darken-3 mr-1"
              style="border-radius: 24px;"
            >
              <v-card
                class="pa-3" color="grey darken-2" elevation="0" style="border-radius: 24px"
                @click="count>1?count--:null"
              >
                <v-icon>mdi-minus</v-icon>
              </v-card>
              <div class="pa-2 mx-1">
                {{ count }}
              </div>
              <v-card
                class="pa-3" color="grey darken-1" elevation="0" style="border-radius: 24px"
                @click="count++"
              >
                <v-icon>mdi-plus</v-icon>
              </v-card>
            </div>

          </div>
          <div class="d-flex mt-2">
            <v-card
              class="pa-3 mr-2 d-flex align-center" color="error" style="border-radius: 24px"
              @click="cancel"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-card>
            <v-card
              v-if="store.state.cantOrderDishes !== '1'"
              class="d-flex align-center justify-center pa-3 px-6 flex-grow-1" color="primary black--text"
              dark
              elevation="0" style="border-radius: 24px"
              @click="submitModification"
            >
              <v-icon class="mr-2" color="black">mdi-basket-plus</v-icon>
              <div class="text-body-1 font-weight-bold">
                {{ realPrice * count|priceDisplay }}
              </div>
            </v-card>
          </div>


        </v-card>
      </div>

    </v-card>
  </v-bottom-sheet>
</template>

<script>
import store from "@/plugins/store";
import {sumBy} from "lodash-es";
import {findIndex} from "lodash";
import {dragscroll} from 'vue-dragscroll'

export default {
  name: "DishDetailSheet",
  props: {show: {}, dish: {}, imageRoot: {}},
  directives: {
    dragscroll,
  },
  data: function () {
    return {
      ids: [],
      selected: false,
      mod: {},
      count: 1,
      note: ''
    };
  },
  watch: {
    show(val) {
      setTimeout(() => {
        if (val) {
          this.computedOption.forEach(it => {
            if (it.multiSelect !== '1') {
              this.$set(this.mod, it.id, 0)
            }
          })
        } else {
          this.ids = []
        }
      }, 200)
    },
    mod: {
      deep: true,
      immediate: true,
      handler(val){
        const result = Object.entries(val).map(([key, value]) => ({
          modId: key,
          value: value
        }))
        if (result) {
          for (const item of result) {
            this.updateCount(this.computedOption.find(it => it.id.toString() === item.modId.toString()).select,item.value)
          }
        }
      }
    }
  },
  computed: {
    currentDescDisplay() {
      return this.dish.dishDesc.replaceAll('/','<br>')
    },
    store() {
      return store
    },
    options() {
      return this.dish.modInfo ?? []
    },
    attrLimit() {
      return parseInt(this.dish?.attrLimit ?? -1)
    },
    multipleSelected() {
      let total = 0
      if (this.computedOption.length > 0) {
        const res = this.computedOption.filter(it => it.multiSelect === '1' && it.required === '0')
        for (const item of res) {
          total += sumBy(item.select, (x) => {
            return x.count
          })
        }
        return total
      } else {
        return 0
      }
    },
    computedOption: function () {
      const realModInfo = []

      this.options.forEach((item) => {
        let i = 0
        item.select = []
        if (!Array.isArray(item.selectName)) {
          item.selectName = item.selectName.split(',')
          item.selectValue = item.selectValue.split(',')
          item.priceInfo = item.priceInfo.split(',')
        }
        if (item.required !== '1' && item.multiSelect !== '1') {
          item.select.push({
            index: i,
            count: 0,
            text: `-`,
            value: -1,
            price: 0,
            priceInfo: ''
          })
          i = i +1
        }
        item.selectName.forEach((name, index) => {
          item.select.push({
            index: i,
            count: this.ids.filter(it => it === item.selectValue[index]).length,
            text: `${name}`,
            value: item.selectValue[index],
            price: parseFloat(item.priceInfo[index]),
            priceInfo: parseFloat(item.priceInfo[index]) === 0 ? '' : `(€${parseFloat(item.priceInfo[index]).toFixed(2)})`
          })
          i++
        })
        realModInfo.push(item)
      })
      return realModInfo
    },
    realMod: function () {
      const realMod = []
      for (const groupId in this.mod) {
        for (const selectIndex of [this.mod[groupId]].flat()) {
          realMod.push({
            groupId,
            selectIndex
          })
        }
      }
      return realMod
    },
    addPrice: function () {
      let total = 0
      if (this.computedOption.length > 0) {
        for (const item of this.computedOption) {
          total += sumBy(item.select, (x) => {
            return x.count * x.price
          })
        }
        return total
      } else {
        return 0
      }
    },
    selectedModString: function () {
      if (this.computedOption.length > 0) {
        return this.modDisplay(this.computedOption.map(it => it.select).flat().filter(x => x.count > 0))
      } else {
        return ''
      }
    },
    realPrice: function () {
      return parseFloat(this.dish.price) + parseFloat(this.addPrice)
    },
    realShow: {
      get: function () {
        return this.show
      },
      set: function () {
        this.cancel()
      }
    }
  },
  methods: {
    modDisplay (modList) {
      return modList.map(it => {
        if (it.count > 1) {
          return it.text + '*' + it.count
        } else {
          return it.text
        }
      }).join(', ')
    },
    currentGroupList (item) {
      const res = this.ids.filter(it => item.selectValue.includes(it))
      return res.length ?? '0'
    },
    updateCount(select,value) {
      const allModIds = select.map(it => it.value)
      this.ids.forEach(it => {
        if (allModIds.includes(it)) {
          this.ids = this.ids.filter(x => x !== it)
        }
      })
      this.ids.push(select[value].value)
    },
    itemText(item) {
      return `${item.text} ${item.priceInfo}`;
    },
    countPlus(item) {
      this.ids.push(item.value)
    },
    countMinus(item) {
      const res = findIndex(this.ids, (x) => {
        return x === item.value
      })
      this.ids.splice(res, 1)
    },
    findModItemUseGroupIdAndIndex(groupId, index) {
      const res = this.computedOption.find(g => parseInt(g.id) === parseInt(groupId))
        .select[parseInt(index)]
      res.totalPrice = res.count * res.price
      return res
    },
    cancel() {
      this.$emit('modification-cancel')
      this.count = 1
      this.mod = {}
    },
    submitModification() {
      const processedNote = this.note.replaceAll("'", " ")
      this.$emit('modification-submit', this.mod, this.count, processedNote)
      this.mod = {}
      this.ids = []
      this.note = ''
      this.count = 1
    }
  }
}
</script>

<style scoped>
.contentContainer {
  padding: 16px;
}

::-webkit-scrollbar {
  display: none;
}

/* Increase font size in textarea */
::v-deep .v-textarea textarea {
  font-size: 1.1rem;
}

.name {
  font-feature-settings: "kern", "ss01", "ss05", "ss07";
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizelegibility;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Roboto, "Open Sans", sans-serif;
  font-variant-ligatures: common-ligatures;
  font-size: 1.75rem;
  line-height: 2.5rem;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  text-transform: none;
  color: rgb(32, 33, 37);
  margin: 0px;
}

</style>
